import React, { useEffect, useState } from "react";
import { AiOutlineDelete } from "react-icons/ai";
import { server } from "../../../common";
import { toast } from "react-toastify";
import { AxiosError } from "axios";
import { useSelectAccess } from "../../../store/stateFunctions";
import { NavLink } from "react-router-dom";
import useQuickLook from "../../../quicklook/useQuickLook";

const InternshipApplications = () => {
  const user = useSelectAccess("Super Admin");
  const [data, setData] = useState([]);
  const displayFile = useQuickLook();

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    server
      .get("/internship/allinternshipapplications", {
        headers: {
          "Content-Type": "application/json",
          Authorization: user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setData(response.data);
        }
      })
      .catch(function (error) {
        toast.error(error);
      });
  };

  return (
    <div className="container">
      <h3 className="my-4 text-center">Internship Application</h3>
      <div style={{ overflow: "scroll" }}>
        <table class="table table-striped border">
          <thead>
            <tr>
              <th>Sr. No.</th>
              <th>Logo</th>
              <th>Company Name</th>
              <th>Position</th>
              <th>Student Name</th>
              <th>Contact No.</th>
              <th>Email Id</th>
              <th>Cover Letter</th>
              <th>Availability</th>
              <th>Resume</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => {
              return (
                <tr key={item.id}>
                  <th scope="row">{index + 1}</th>
                  <td>
                    <img src={item.image} width={50} alt="" />
                  </td>
                  <td>{item.company_name}</td>
                  <td>{item.position}</td>
                  <td>{item.name}</td>
                  <td>{item.contactno}</td>
                  <td>{item.email}</td>
                  <td>{item.letter_description}</td>
                  <td>{item.availability}</td>
                  <td>
                    <a
                      href={item.images}
                      className="p-1 border-0 rounded-2 banner text-white"
                      target="_blank"
                    >
                      view
                    </a>
                  </td>

                  {/* <td>
                    <NavLink
                      className="banner text-white p-2 rounded-3"
                      to="/industryprofile/positions-internship"
                    >
                      View
                    </NavLink>
                  </td> */}
                  {/* <td>
                    <div className="btn banner text-white">
                      <AiFillEdit onClick={() => handleShowGallery(item)} />
                    </div>
                  </td>
                  <td>
                    <div className="btn banner text-white">
                      <AiFillDelete onClick={() => handleDelete(item)} />
                    </div>
                  </td> */}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default InternshipApplications;
